import { CreditCard } from 'lucide-react';

export function PaymentsTab({ payments, fmt, fmtDate }) {
  if (payments.length === 0) return <div className="bg-white rounded-xl border border-gray-200 p-12 text-center"><CreditCard className="w-12 h-12 text-gray-300 mx-auto mb-4" /><p className="text-gray-500">No payments yet</p></div>;
  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <table className="w-full"><thead className="bg-gray-50"><tr>
        <th className="text-left px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Type</th>
        <th className="text-left px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Date</th>
        <th className="text-right px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Amount</th>
        <th className="text-right px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Fee</th>
        <th className="text-right px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Total Charged</th>
        <th className="text-center px-6 py-3 text-xs font-semibold text-gray-500 uppercase">Status</th>
      </tr></thead><tbody className="divide-y">
        {payments.map(pay => (
          <tr key={pay.id} className="hover:bg-gray-50">
            <td className="px-6 py-4 font-medium capitalize">{pay.type}</td>
            <td className="px-6 py-4 text-gray-600">{fmtDate(pay.created_at)}</td>
            <td className="px-6 py-4 text-right font-semibold">{fmt(pay.amount)}</td>
            <td className="px-6 py-4 text-right text-amber-600">{pay.processing_fee > 0 ? fmt(pay.processing_fee) : '-'}</td>
            <td className="px-6 py-4 text-right font-semibold text-green-700">{pay.transaction_amount > 0 ? fmt(pay.transaction_amount) : fmt(pay.amount)}</td>
            <td className="px-6 py-4 text-center"><span className={`px-2.5 py-1 rounded-full text-xs font-semibold ${pay.payment_status === 'paid' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>{(pay.payment_status || 'pending').toUpperCase()}</span></td>
          </tr>
        ))}
      </tbody></table>
    </div>
  );
}
